export default "__VITE_ASSET__DfkjOyLt__"